import { orderBy } from "lodash";

import { MODULE } from "./individualTimesheets.actionTypes";

export const isFetchingSummaryStatus = (state) => state.getIn([MODULE, "isFetchingSummaryStatus"]);

export const getIndividualSummary = (state) => {
  const summary = state.getIn([MODULE, "individualSummary"]);

  if (!summary) {
    return { timesheet: [] };
  }

  const { timesheet } = summary;

  if (!timesheet) {
    return { ...summary, timesheet: [] };
  }

  // Check if this is a grouped response (timesheet is an object with date keys)
  // vs standard response (timesheet is an array)
  if (Array.isArray(timesheet)) {
    // Standard format - timesheet is an array
    return {
      ...summary,
      timesheet: timesheet.map((t) => ({
        ...t,
        timeEntries: t.timeEntries
          ? t.timeEntries.map((e) => ({
              ...e,
              productName: e.productName || null,
            }))
          : [],
      })),
    };
  }

  if (typeof timesheet === "object") {
    // Grouped format - timesheet is an object with date keys
    return {
      ...summary,
      timesheet: Object.keys(timesheet).map((dateKey) => {
        const dayData = timesheet[dateKey];
        return {
          ...dayData,
          // For grouped format, we need to handle timeEntries within each category
          work: dayData.work
            ? {
                ...dayData.work,
                timeEntries: dayData.work.timeEntries
                  ? dayData.work.timeEntries.map((e) => ({
                      ...e,
                      productName: e.productName || null,
                    }))
                  : [],
              }
            : null,
          attendance: dayData.attendance
            ? {
                ...dayData.attendance,
                timeEntries: dayData.attendance.timeEntries
                  ? dayData.attendance.timeEntries.map((e) => ({
                      ...e,
                      productName: e.productName || null,
                    }))
                  : [],
              }
            : null,
          breaks: dayData.breaks || null,
          date: dateKey,
        };
      }),
    };
  }

  // Fallback: unsupported shape
  return { ...summary, timesheet: [] };
};

export const getFromDate = (state) => state.getIn([MODULE, "fromDate"]);

export const getToDate = (state) => state.getIn([MODULE, "toDate"]);

export const getDates = (state) => state.getIn([MODULE, "dates"]);

export const isUpdatingTimeEntryStatus = (state) =>
  state.getIn([MODULE, "isUpdatingTimeEntryStatus"]);

export const getSelectedUserIds = (state) => state.getIn([MODULE, "selectedUserIds"]);

export const getModalType = (state) => state.getIn([MODULE, "modalType"]);

export const getActiveUser = (state) => state.getIn([MODULE, "activeUser"]);

export const getSelectedTimeEntryUids = (state) => state.getIn([MODULE, "selectedTimeEntryUids"]);

export const isFetchingTeamMembersStatus = (state) =>
  state.getIn([MODULE, "isFetchingTeamMembersStatus"]);

export const getTeamMembers = (state) =>
  orderBy(state.getIn([MODULE, "teams"]), [(l) => l.firstName.toLowerCase()]);

export const isDeletingStatus = (state) => state.getIn([MODULE, "isDeletingStatus"]);

export const getExpandedDates = (state) => state.getIn([MODULE, "expandedDates"]);

export const getActiveTimeEntry = (state) => state.getIn([MODULE, "activeTimeEntry"]);

export const isSubmittingTimesheetToAccountingStatus = (state) =>
  state.getIn([MODULE, "isSubmittingTimesheetToAccountingStatus"]);
